const VISITED_PATHS_KEY = 'authorizer_visited_paths';

/** Reads visited paths from sessionStorage. Returns an empty set when unavailable. */
export function getVisitedPaths(): Set<string> {
	if (typeof window === 'undefined') return new Set();
	try {
		const raw = sessionStorage.getItem(VISITED_PATHS_KEY);
		return new Set(raw ? (JSON.parse(raw) as string[]) : []);
	} catch {
		return new Set();
	}
}

/**
 * Marks a path as visited.
 * @returns true when the path was already visited (cycle detected).
 */
export function markPathVisited(path: string): boolean {
	if (typeof window === 'undefined') return false;
	try {
		const visited = getVisitedPaths();
		const hasCycle = visited.has(path);
		visited.add(path);
		sessionStorage.setItem(VISITED_PATHS_KEY, JSON.stringify([...visited]));
		return hasCycle;
	} catch {
		return false;
	}
}

/** Clears visited paths from sessionStorage. */
export function clearVisitedPaths(): void {
	if (typeof window === 'undefined') return;
	try {
		sessionStorage.removeItem(VISITED_PATHS_KEY);
	} catch {
		// Ignore storage errors
	}
}
